export const GOALS_DAILY_FETCH = '[Goals] Goals Daily Fetch'
export const GOALS_DAILY_FETCH_SUCCESS = '[Goals] Goals Daily Fetch Success'
export const GOALS_DAILY_FETCH_ERROR = '[Goals] Goals Daily Fetch Error'
export const fetchGoalsDaily = store => ({ type: GOALS_DAILY_FETCH, payload: store })

export const GOALS_MONTH_FETCH = '[Goals] Goals Month Fetch'
export const GOALS_MONTH_FETCH_SUCCESS = '[Goals] Goals Month Fetch Success'
export const GOALS_MONTH_FETCH_ERROR = '[Goals] Goals Month Fetch Error'
export const fetchGoalsMonth = store => ({ type: GOALS_MONTH_FETCH, payload: store })